
import { SyntheticEvent } from 'react';
import styled from 'styled-components';
import { Featured } from 'src/types';
import { formatLink } from 'src/utils/featuredPosts';
import i18n from 'src/utils/translate';
import { LinkButton } from 'styles-js/buttons';

type Props = {
  featuredPost: Featured;
  onClick: (e: SyntheticEvent) => void;
  onDismiss: () => void;
}

export default function NormalFeaturedPost({featuredPost, onClick, onDismiss}: Props) {
  const formattedLink = formatLink(featuredPost.callToActionUrl);

  return (
    <div className="results-post">
      {featuredPost.imageUrl &&
        <a
          href={formattedLink}
          rel="nofollow ugc"
          target="_blank"
          onClick={onClick}
        >
          <img alt={featuredPost.title} className="featured-post__image" src={featuredPost.imageUrl} />
        </a>
      }
      <Title className="results-post__title">
        <a
          href={formattedLink}
          rel="nofollow ugc"
          target="_blank"
          onClick={onClick}
        >
          {featuredPost.title}
        </a>
        <LinkButton onClick={onDismiss}>{i18n.t('Hide')}</LinkButton>
      </Title>
      <div className="results-post__body">
        {featuredPost.snippet}
      </div>
      <div>
        <a
          className="btn btn-secondary"
          href={formattedLink}
          rel="nofollow ugc"
          target="_blank"
          onClick={onClick}
        >
          <span className="featured-post__call-to-action">
            {featuredPost.callToActionText}
          </span>
        </a>
      </div>
      <div className="featured-post__footer">
        <div className="featured-post__footer--content">
          {i18n.t('Featured by')} {featuredPost.featuredByCommunityName}
        </div>
      </div>
    </div>
  );
}

export const Title = styled.h3`
  display: flex;
  a {
    flex: 1;
  }
  button {
    align-self: flex-start;
  }
`;
